import { Component } from '@theme/component';

// Server-rendered v4.2 geometry stays visible even if this module cannot load.
class BarryGlyphMotion extends HTMLElement {
  phase = 'idle';
  connectedCallback() {
    this.cleanup();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.trigger = this.closest('[data-glyph-trigger]');
    this.svg = this.querySelector('.bc-motion-glyph');
    if (!this.trigger || !this.svg) return;
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const syncPreference = () => { this.svg.dataset.reduced = String(this.reduced.matches); };
    syncPreference();
    this.reduced.addEventListener('change', syncPreference, options);
    this.trigger.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse' && !this.reduced.matches) this.preview();
    }, options);
    this.trigger.addEventListener('pointerleave', () => {
      if (!this.trigger.contains(document.activeElement)) this.release();
    }, options);
    this.trigger.addEventListener('focusin', () => this.preview(), options);
    this.trigger.addEventListener('focusout', event => {
      if (!this.trigger.contains(event.relatedTarget)) this.release();
    }, options);
  }
  preview() { if (this.phase !== 'active') this.setPhase('preview'); }
  activate() { this.setPhase('active'); }
  release() {
    if (this.phase === 'active') return;
    this.setPhase('release');
    this.releaseTimer = setTimeout(() => this.setPhase('idle'), 240);
  }
  reset() { this.setPhase('idle'); }
  setPhase(phase) {
    clearTimeout(this.releaseTimer);
    this.phase = phase;
    this.dataset.phase = phase;
    if (this.svg) this.svg.dataset.state = phase === 'release' ? 'idle' : phase;
  }
  cleanup() { this.controller?.abort(); clearTimeout(this.releaseTimer); }
  disconnectedCallback() { this.cleanup(); }
}

// Native inquiry links work before this enhancement loads. Do not intercept navigation.
class BarryServicePicker extends Component {
  connectedCallback() { super.connectedCallback(); this.setup(); }
  updatedCallback() { super.updatedCallback(); this.setup(); }
  setup() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.rows = [...this.querySelectorAll('[data-service-row]')];
    const reset = () => {
      for (const row of this.rows) {
        row.dataset.state = 'idle';
        row.querySelector('bc-glyph-motion')?.reset();
      }
    };
    reset();
    window.addEventListener('pageshow', reset, options);
    for (const row of this.rows) {
      const link = row.querySelector('[data-service-link]');
      if (!link) continue;
      link.addEventListener('click', event => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        row.dataset.state = 'active';
        row.querySelector('bc-glyph-motion')?.activate();
      }, options);
    }
  }
  disconnectedCallback() { this.controller?.abort(); super.disconnectedCallback(); }
}

if (!customElements.get('bc-glyph-motion')) customElements.define('bc-glyph-motion', BarryGlyphMotion);
if (!customElements.get('bc-service-picker')) customElements.define('bc-service-picker', BarryServicePicker);
